import { action as apiAction } from 'api/Api'
import {
  removeItem as removeItemFromElement
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  documentSourceId: number;
  url: string;
  documentListItemId: number;
  documentListId: number;
}

const requestRemoveDocument = (payload: Payload) => async dispatch => {
  const { documentSourceId, url, documentListItemId, documentListId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeItemFromElement({
    elementId: documentListId,
    itemId: documentListItemId
  }))

  try {
    await apiAction('RemoveFile', {
      documentsSourceId: documentSourceId,
      url
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestRemoveDocument
